import { defineComponent } from 'vue';
import { IClient } from '@/shared/model/client.model';
import { ICompany } from '@/shared/model/company.model';

export default defineComponent({
  props: {
    hourlyCost: {
      type: Number,
      required: true
    },
    numStemdoers: {
      type: Number,
      required: true
    },
    company: {
      type: Object as () => ICompany,
      required: false
    },
    isUserClient: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    return {};
  }
});
